var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSelectedProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 52,
    viewBox: "0 0 20 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0031 30.8C7.10312 30.8 4.75112 28.383 4.75112 25.4C4.75112 22.418 7.10212 20 10.0031 20C12.9031 20 15.2531 22.418 15.2531 25.4C15.2531 28.383 12.9031 30.8 10.0031 30.8ZM17.7371 35.623C18.0871 36.317 18.0871 37.143 17.7371 37.838C17.2701 38.728 16.2231 39.315 14.4931 39.618C13.7221 39.773 12.9411 39.874 12.1571 39.92C11.4301 40 10.7031 40 9.96812 40H8.64412C8.36812 39.964 8.09912 39.947 7.84012 39.947C7.05512 39.907 6.27512 39.808 5.50412 39.653C3.83412 39.333 2.74412 38.763 2.27712 37.873C2.09712 37.529 2.00212 37.144 2.00012 36.753C1.99612 36.359 2.08912 35.97 2.26812 35.623C2.72712 34.733 3.81712 34.155 5.50412 33.843C6.27812 33.691 7.06112 33.593 7.84812 33.55C9.28812 33.434 10.7341 33.434 12.1741 33.55C12.9581 33.596 13.7381 33.694 14.5101 33.843C16.1801 34.181 17.2701 34.733 17.7371 35.623Z",
    fill: "#585B63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 49,
    r: 3,
    fill: "#9698F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectedProfile);
export default __webpack_public_path__ + "static/media/ic_selected_profile.f0e326252e08b22e27f1c48e20a486f7.svg";
export { ForwardRef as ReactComponent };